const RUNTIME_ENV = process.env.NODE_ENV === 'production' ? 'production' : 'development'
// const RUNTIME_ENV = ''

const BASE_URL = RUNTIME_ENV === 'production' ? 'https://artlensgroup.com' : RUNTIME_ENV === 'development' ? 'https://test.artlensgroup.com' : 'http://localhost:8000'
const IMAGE_URL = 'https://images.artlensgroup.com'
const API_BASE_URL = `${BASE_URL}/api/v1`

export {
    BASE_URL,
    IMAGE_URL,
    API_BASE_URL,
	RUNTIME_ENV
}
